import React from 'react';
import { Box, BoxProps } from '../Box/Box';

export const Separator: React.FC<BoxProps> = props => {
  return <Box role="separator" height={1} bg="neutral.200" {...props} />;
};
